export const GET_FEE_HISTORY = 'GET_FEE_HISTORY'
export const DOWNLOAD_VOUCHER = 'DOWNLOAD_VOUCHER'
export const GET_STUDENT_PROFILE_FEE_PARTICULARS = 'GET_STUDENT_PROFILE_FEE_PARTICULARS'
export const GET_CLASS_FEE_PACKAGE_DETAILS = 'GET_CLASS_FEE_PACKAGE_DETAILS'
export const GET_CLASS_PARTICULARS = 'GET_CLASS_PARTICULARS'
export const GENERATE_MONTHLY_AUDIT_SUMMARY = 'GENERATE_MONTHLY_AUDIT_SUMMARY'
export const GET_STUDENT_FEES = 'GET_STUDENT_FEES'
export const FETCH_FEE_SETTINGS = 'FETCH_FEE_SETTINGS'
